import { atom } from "recoil"

export const teamMembersCsvDataRequestIdState = atom<number>({
  key: "atoms/csvData/teamMembersCsvDataRequestIdState",
  default: 0,
})
